<div class="banner" fetchpriority="high" [ngStyle]="{backgroundPositionY: position, backgroundImage: 'url('+preview+')'}" (click)="show_video = true">
	<!-- <img [src]="preview" /> -->
	<p class="play">►</p>
	<p *ngIf="text">{{text}}</p>
</div>

<div class="backdrop" *ngIf="show_video" (click)="show_video = false">
	<p (click)="show_video = false" class="close">&#9587;</p>
	<iframe *ngIf="video_url" [src]="video_url" allowfullscreen></iframe>
</div>
